import { Bar, BarChart, CartesianGrid, LabelList, XAxis, YAxis } from "recharts"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "./Card"
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "./Chart"

export default function BarChartOrders({ data }) {
  const chartConfig = {
    value: {
      label: "Orders",
    },
    label: {
      color: "var(--color-primary-500)",
    },
  }

  const chartData = data.map(item => {
    const d = new Date(item.date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); 
    const year = d.getFullYear();
    return {
      date: `${day}-${month}-${year}`,
      value: Number(item.order_count),
    };
  });

  const totalOrders = chartData.reduce((sum, item) => sum + Number(item.value), 0);
  const avgOrders = chartData.length > 0 ? (totalOrders / chartData.length).toFixed(1) : 0;

  return (
    <Card className="shadow-none border-none">
      <CardHeader>
        <CardTitle>Commandes par jour</CardTitle>
        <CardDescription className="text-xs">
          Nombre quotidien de commandes
        </CardDescription>
      </CardHeader>

      <CardContent>
        <ChartContainer config={chartConfig} className="h-80 w-full">
          <BarChart data={chartData} margin={{ right: 16 ,top: 12}}>
            <CartesianGrid stroke="#aaaaaa50" strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tickLine={false}
              tickMargin={10}
              axisLine={false}
              className="text-[10px]"
            />
            <YAxis 
              tickLine={false}
              axisLine={false}
              className="text-[10px]"
              allowDecimals={false}
            />
            <ChartTooltip
              cursor={{ fill: "rgba(0,0,0,0.05)" }}
              content={<ChartTooltipContent className="relative bg-white text-gray-600 border border-slate-200 shadow-lg pl-4 
                before:absolute before:left-2.5 before:top-[5px] before:bottom-0 
                before:w-1 before:h-8 before:rounded-xl before:bg-[var(--color-primary-500)] before:content-['']" indicator="line" />}
            />
            
            <Bar dataKey="value" fill="var(--color-primary-500)" radius={4}>
              <LabelList
                dataKey="value"
                position="top"
                className="fill-foreground"
                fontSize={10}
                formatter={(val) => (val === 0 ? "" : `${val}`)}
              />
            </Bar>
          </BarChart>
        </ChartContainer>
      </CardContent>

      <CardFooter className="flex-col items-start gap-2 text-sm">
        <div className="flex gap-2 leading-none font-medium text-green-600 mt-1">
          Total commandes : {totalOrders}
        </div>
        <div className="text-muted-foreground text-xs leading-none">
          Moyenne journalière : {avgOrders} / jour
        </div>
      </CardFooter>
    </Card>
  )
}
